import { Release, usePromoteReleaseMutation } from '../../gql/generated';
import React from 'react';
import { ModalContent } from '../manage-tags/ModalContent';
import { ModalBodyText } from '../../StyledComponents/Typography';
import { useRoleAuthorization } from '../auth/RoleAuthorization';
import { StyledModal } from '../StyledModal';

interface PromoteModalProps {
  release: Release;
  isVisible: boolean;
  onClose: () => void;
  refetch: () => void;
}

export const PromoteModal = (props: PromoteModalProps) => {
  const { isVisible, onClose, refetch, release } = props;
  const [promoteRelease, { loading, error }] = usePromoteReleaseMutation();
  const { getPromotionTarget } = useRoleAuthorization();

  const handleClose = () => {
    refetch();
    onClose();
  };

  const onPromoteConfirm = async () => {
    if (!release || !release.id) {
      return;
    }
    await promoteRelease({
      variables: {
        releaseId: release.id,
      },
      onCompleted: () => {
        handleClose();
      },
    });
  };

  return (
    <StyledModal
      isOpen={isVisible}
      onRequestClose={handleClose}
      label="promote-modal"
    >
      <ModalContent
        title={`Promote OTA Release ${release?.semver}`}
        loading={loading}
        error={error}
        handleSubmit={onPromoteConfirm}
        submitDisabled={loading}
        handleClose={handleClose}
        buttonLabels={{ loading: 'Promoting Release...', create: 'Promote' }}
      >
        <ModalBodyText>New Environment</ModalBodyText>
        <ModalBodyText bold={true}>{getPromotionTarget() || ''}</ModalBodyText>
      </ModalContent>
    </StyledModal>
  );
};
